import React from "react";
import { displayCurrency } from "../services/helpers/currency-display";

export default function Currency({ children, className }) {
  const currency = displayCurrency(children);

  if (!currency) {
    return null;
  }

  return <span className={className}>{currency}</span>;
}
